'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useRef } from 'react';
import ReactMarkdown from 'react-markdown';
interface MarkdownWrapperProps {
  content: string;
  className?: string;
  variant?: 'default' | 'legal';
}
interface ImageProps {
  src?: string | Blob;
  alt?: string;
  title?: string;
}
const MarkdownWrapper = t0 => {
  const $ = _c(6);
  const {
    content,
    className: t1,
    variant: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const variant = t2 === undefined ? "default" : t2;
  const firstImageFoundRef = useRef(false);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      img: t4 => {
        const {
          src,
          alt,
          title
        } = t4;
        const isFirstImage = !firstImageFoundRef.current;
        if (isFirstImage) {
          firstImageFoundRef.current = true;
        }
        const imageSrc = src instanceof Blob ? URL.createObjectURL(src) : src || "";
        return <div className="relative w-full h-64 my-4" title={title}><Image src={imageSrc} alt={alt || ""} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw" className="object-contain" priority={isFirstImage} /></div>;
      }
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const components = t3;
  const t4 = `
        ${variant === "legal" ? `
          prose lg:prose-lg xl:prose-xl max-w-none
          prose-headings:font-serif prose-headings:font-bold prose-headings:leading-tight prose-headings:tracking-tight
          prose-h1:text-4xl md:prose-h1:text-5xl prose-h1:mt-8 prose-h1:mb-6 prose-h1:text-gray-900 dark:prose-h1:text-gray-100
          prose-h2:text-3xl md:prose-h2:text-4xl prose-h2:mt-12 prose-h2:mb-6 prose-h2:text-gray-900 dark:prose-h2:text-gray-100
          prose-h3:text-2xl md:prose-h3:text-3xl prose-h3:mt-8 prose-h3:mb-4 prose-h3:text-gray-800 dark:prose-h3:text-gray-200
          prose-p:text-gray-700 dark:prose-p:text-gray-300 prose-p:leading-relaxed prose-p:my-6
          prose-a:text-blue-600 dark:prose-a:text-blue-400 prose-a:no-underline prose-a:border-b prose-a:border-transparent hover:prose-a:text-blue-800 hover:prose-a:border-blue-800 dark:hover:prose-a:text-blue-300 dark:hover:prose-a:border-blue-300
          prose-ul:my-6 prose-ul:list-disc prose-ul:pl-6
          prose-ol:my-6 prose-ol:pl-6
          prose-li:my-2 prose-li:pl-2 prose-li:text-gray-700 dark:prose-li:text-gray-300
          prose-blockquote:border-l-4 prose-blockquote:border-gray-300 dark:prose-blockquote:border-gray-600 prose-blockquote:bg-gray-50 dark:prose-blockquote:bg-gray-800 prose-blockquote:text-gray-700 dark:prose-blockquote:text-gray-300 prose-blockquote:italic prose-blockquote:my-8 prose-blockquote:py-2 prose-blockquote:pl-6
          prose-hr:border-gray-200 dark:prose-hr:border-gray-700 prose-hr:my-12
          prose-strong:font-semibold prose-strong:text-gray-900 dark:prose-strong:text-gray-100
        ` : `
          prose lg:prose-lg max-w-none
          prose-headings:font-serif prose-headings:font-bold prose-headings:leading-tight prose-headings:tracking-tight prose-headings:text-center
          prose-h1:text-4xl md:prose-h1:text-5xl prose-h1:mt-8 prose-h1:mb-6 prose-h1:pb-4 prose-h1:text-primary dark:prose-h1:text-primary-light prose-h1:relative prose-h1:after:content-[''] prose-h1:after:absolute prose-h1:after:bottom-0 prose-h1:after:left-1/2 prose-h1:after:-translate-x-1/2 prose-h1:after:w-24 prose-h1:after:h-1 prose-h1:after:bg-linear-to-r prose-h1:after:from-primary prose-h1:after:to-primary-light dark:prose-h1:after:from-primary-light dark:prose-h1:after:to-primary prose-h1:after:rounded
          prose-h2:text-3xl md:prose-h2:text-4xl prose-h2:mt-12 prose-h2:mb-6 prose-h2:pb-4 prose-h2:text-primary dark:prose-h2:text-primary-light prose-h2:relative prose-h2:after:content-[''] prose-h2:after:absolute prose-h2:after:bottom-0 prose-h2:after:left-1/2 prose-h2:after:-translate-x-1/2 prose-h2:after:w-16 prose-h2:after:h-0.5 prose-h2:after:bg-linear-to-r prose-h2:after:from-primary prose-h2:after:to-primary-light dark:prose-h2:after:from-primary-light dark:prose-h2:after:to-primary prose-h2:after:rounded
          prose-h3:text-2xl md:prose-h3:text-3xl prose-h3:mt-8 prose-h3:mb-4 prose-h3:pb-2 prose-h3:text-primary-dark dark:prose-h3:text-primary-light prose-h3:relative prose-h3:after:content-[''] prose-h3:after:absolute prose-h3:after:bottom-0 prose-h3:after:left-1/2 prose-h3:after:-translate-x-1/2 prose-h3:after:w-12 prose-h3:after:h-px prose-h3:after:bg-primary-light/50 dark:prose-h3:after:bg-primary/50 prose-h3:after:rounded
          prose-p:text-gray-700 dark:prose-p:text-gray-300 prose-p:leading-relaxed prose-p:my-6 prose-p:text-center
          prose-a:text-primary dark:prose-a:text-primary-light prose-a:no-underline prose-a:border-b prose-a:border-transparent hover:prose-a:text-primary-dark dark:hover:prose-a:text-primary hover:prose-a:border-primary-dark dark:hover:prose-a:border-primary
          prose-ul:my-6 prose-ul:w-full prose-ul:md:w-2/3 prose-ul:xl:w-1/2 prose-ul:mx-auto prose-ul:rounded-xl prose-ul:pr-6 prose-ul:pl-10 prose-ul:py-4 prose-ul:bg-primary-light/15 dark:prose-ul:bg-primary/15 prose-ul:[&>li::marker]:text-primary dark:prose-ul:[&>li::marker]:text-primary-light prose-ul:[&>li::marker]:text-lg
          prose-ol:my-6 prose-ol:pl-6
          prose-li:my-3 prose-li:pl-2 dark:prose-li:text-gray-300
          prose-blockquote:border-l-4 prose-blockquote:border-primary-light/50 dark:prose-blockquote:border-primary/50 prose-blockquote:bg-primary-light/5 dark:prose-blockquote:bg-primary/5 prose-blockquote:text-gray-700 dark:prose-blockquote:text-gray-300 prose-blockquote:italic prose-blockquote:my-8 prose-blockquote:py-2 prose-blockquote:pl-6 prose-blockquote:rounded-r-lg
          prose-hr:border-gray-200 dark:prose-hr:border-gray-700 prose-hr:my-12
          prose-img:rounded-xl prose-img:shadow-md
          prose-strong:font-bold prose-strong:text-primary-dark dark:prose-strong:text-primary-light
        `}
        ${className}
      `;
  let t5;
  if ($[1] !== content) {
    t5 = <ReactMarkdown components={components}>{content}</ReactMarkdown>;
    $[1] = content;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t4 || $[4] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export default MarkdownWrapper;